import { SuiteType } from './item.model';

export const ENTITY_NAMES = {
  availability: 'availability',
  tenancy: 'tenancy',
  lease: 'lease',
  company: 'company',
  brand: 'brand',
  unaccounted: 'lease',
};

export const ENTITY_IDS = {
  lease: 'leaseId',
  company: 'companyId',
  availability: 'id',
  tenancy: 'tenantId',
};

export const COLUMN_MAPPER_ENTITIES = [SuiteType.Availability, SuiteType.Tenant, SuiteType.Lease];
